'use strict'

const moduleConfig = require('../utils/module-config')

module.exports = (arg) => {
  const send = moduleConfig(arg)

  return {
    get: require('./get')(send),
    put: require('./put')(send)
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/dag/index.js
// module id = 384
// module chunks = 0